<script>
export default {
    name: 'PromotionCollection_BestSellerCard',
    props: {
        card: Object,
        label: Object,
    }
}
</script>

<template>
    <article class="nti-promotion__best-seller-card">
        <a :href="card.link" class="nti-promotion__best-seller-card__link-container">
            <div class="nti-promotion__best-seller-card__image">
                <img v-if="card.imageUrl" :src="card.imageUrl" alt="product image">
            </div>
            <div class="nti-promotion__best-seller-card__left-container">
                <h3 class="nti-promotion__best-seller-card__title">{{ card.title }}</h3>
                <h3 class="nti-promotion__best-seller-card__price">
                    <span class="nti-promotion__best-seller-card__small-font">
                        {{ label.fromLabel }}
                    </span>
                    {{ card.priceText }}
                </h3>
            </div>
        </a>
    </article>
</template>